(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-application"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('partner-application-form')) {
    const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    class PartnerApplicationForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;

        this.summary = this.querySelector('[data-error-summary]');
        this.summaryText = this.querySelector('[data-error-summary-text]');
        this.submitButton = this.form.querySelector('[type="submit"]');

        this.onSubmit = this.onSubmit.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onPageShow = this.onPageShow.bind(this);

        this.form.addEventListener('submit', this.onSubmit);
        this.form.addEventListener('input', this.onFieldChange);
        this.form.addEventListener('change', this.onFieldChange);
        this.form.addEventListener('focusout', this.onFocusOut);
        window.addEventListener('pageshow', this.onPageShow);
      }

      disconnectedCallback() {
        window.removeEventListener('pageshow', this.onPageShow);
      }

      get fields() {
        return Array.from(this.form.querySelectorAll('[data-field]'));
      }

      validateField(field) {
        const controls = Array.from(field.querySelectorAll('input, textarea, select'));
        const error = field.querySelector('.partner-form__error');
        let message = '';

        if (field.hasAttribute('data-required-choice')) {
          if (!controls.some((control) => control.checked)) message = this.dataset.msgChoice;
        } else {
          const control = controls[0];
          const value = control.value.trim();
          if (control.required && !value) {
            message = this.dataset.msgRequired;
          } else if (control.type === 'email' && value && !EMAIL_PATTERN.test(value)) {
            message = this.dataset.msgEmail;
          }
        }

        field.classList.toggle('is-invalid', Boolean(message));
        controls.forEach((control) => {
          if (message) control.setAttribute('aria-invalid', 'true');
          else control.removeAttribute('aria-invalid');
        });

        if (error) {
          error.textContent = message;
          error.hidden = !message;
        }

        return !message;
      }

      onFieldChange(event) {
        const field = event.target.closest('[data-field]');
        if (field && field.classList.contains('is-invalid')) {
          this.validateField(field);
          if (!this.form.querySelector('[data-field].is-invalid')) this.hideSummary();
        }
      }

      onFocusOut(event) {
        if (event.target.type === 'email' && event.target.value.trim()) {
          this.validateField(event.target.closest('[data-field]'));
        }
      }

      onSubmit(event) {
        const invalid = this.fields.filter((field) => !this.validateField(field));

        if (invalid.length) {
          event.preventDefault();
          this.showSummary(invalid.length);
          const firstControl = invalid[0].querySelector('input, textarea, select');
          if (firstControl) firstControl.focus();
          return;
        }

        this.hideSummary();
        if (this.submitButton) {
          this.submitButton.setAttribute('aria-busy', 'true');
          setTimeout(() => (this.submitButton.disabled = true), 0);
        }
      }

      onPageShow() {
        if (this.submitButton) {
          this.submitButton.disabled = false;
          this.submitButton.removeAttribute('aria-busy');
        }
      }

      showSummary(count) {
        if (!this.summary) return;
        this.summaryText.textContent = this.dataset.msgSummary.replace('[count]', count);
        this.summary.hidden = false;
      }

      hideSummary() {
        if (this.summary) this.summary.hidden = true;
      }
    }

    customElements.define('partner-application-form', PartnerApplicationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sourcing-request"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sourcing-request-form')) {
    const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    class SourcingRequestForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;

        this.summary = this.querySelector('[data-error-summary]');
        this.summaryText = this.querySelector('[data-error-summary-text]');
        this.submitButton = this.form.querySelector('[type="submit"]');

        this.onSubmit = this.onSubmit.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onPageShow = this.onPageShow.bind(this);

        this.form.addEventListener('submit', this.onSubmit);
        this.form.addEventListener('input', this.onFieldChange);
        this.form.addEventListener('change', this.onFieldChange);
        this.form.addEventListener('focusout', this.onFocusOut);
        window.addEventListener('pageshow', this.onPageShow);
      }

      disconnectedCallback() {
        window.removeEventListener('pageshow', this.onPageShow);
      }

      get fields() {
        return Array.from(this.form.querySelectorAll('[data-field]'));
      }

      validateField(field) {
        const control = field.querySelector('input, textarea, select');
        const error = field.querySelector('.sourcing-form__error');
        const value = control.value.trim();
        let message = '';

        if (control.required && !value) {
          message = this.dataset.msgRequired;
        } else if (control.type === 'email' && value && !EMAIL_PATTERN.test(value)) {
          message = this.dataset.msgEmail;
        }

        field.classList.toggle('is-invalid', Boolean(message));
        if (message) control.setAttribute('aria-invalid', 'true');
        else control.removeAttribute('aria-invalid');

        if (error) {
          error.textContent = message;
          error.hidden = !message;
        }

        return !message;
      }

      onFieldChange(event) {
        const field = event.target.closest('[data-field]');
        if (field && field.classList.contains('is-invalid')) {
          this.validateField(field);
          if (!this.form.querySelector('[data-field].is-invalid')) this.hideSummary();
        }
      }

      onFocusOut(event) {
        if (event.target.type === 'email' && event.target.value.trim()) {
          this.validateField(event.target.closest('[data-field]'));
        }
      }

      onSubmit(event) {
        const invalid = this.fields.filter((field) => !this.validateField(field));

        if (invalid.length) {
          event.preventDefault();
          this.showSummary(invalid.length);
          const first = invalid[0].querySelector('input, textarea, select');
          if (first) first.focus();
          return;
        }

        this.hideSummary();
        if (this.submitButton) {
          this.submitButton.setAttribute('aria-busy', 'true');
          setTimeout(() => (this.submitButton.disabled = true), 0);
        }
      }

      onPageShow() {
        if (this.submitButton) {
          this.submitButton.disabled = false;
          this.submitButton.removeAttribute('aria-busy');
        }
      }

      showSummary(count) {
        if (!this.summary) return;
        this.summaryText.textContent = this.dataset.msgSummary.replace('[count]', count);
        this.summary.hidden = false;
      }

      hideSummary() {
        if (this.summary) this.summary.hidden = true;
      }
    }

    customElements.define('sourcing-request-form', SourcingRequestForm);
  }

  } catch(e) { console.error(e); }
})();
})();
